<app-vehicle-years-step
  class="ion-page"
  [isOpen]="isVehicleYearsStep$ | async"
  (selected)="yearChange($event)"
  [tabIndexPosition]="tabIndexPosition"
  (back)="handleBack()"
></app-vehicle-years-step>
